import styled from "styled-components";

export const ServicesContainer = styled.div`
  min-height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #010606;
  padding: 40px 20px;

  @media screen and (max-width: 768px) {
    min-height: 1100px;
  }

  @media screen and (max-width: 480px) {
    min-height: 1300px;
  }
`;

export const ServicesWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 24px;
  padding: 0 50px;

  & > * {
    flex: 0 1 calc(33.333% - 16px);
    min-width: 280px;
  }

  @media screen and (max-width: 1000px) {
    & > * {
      flex: 0 1 calc(50% - 12px);
    }
  }

  @media screen and (max-width: 768px) {
    & > * {
      flex: 0 1 100%;
    }
    padding: 0 20px;
  }
`;

export const ServicesCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 12px;
  height: 400px; /* Fixed height for consistency */
  width: 100%; /* Full width of container */
  max-width: 320px; /* Max width for cards */
  padding: 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease-in-out;
  box-sizing: border-box; /* Include padding in height calculation */

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

export const ServicesIcon = styled.img`
  height: 140px;
  width: 140px;
  margin-bottom: 16px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e5e7eb;
  flex-shrink: 0; /* Prevent image from shrinking */
`;

export const ServicesP = styled.p`
  font-size: 0.85rem;
  color: #374151;
  text-align: center;
  line-height: 1.5;
  margin: 0;
  flex-grow: 1; /* Allow description to take remaining space */
  display: flex;
  align-items: center; /* Center text vertically */
  width: 100%;

  @media screen and (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const ServicesH1 = styled.h1`
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 64px;
  font-weight: 700;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const ServicesH2 = styled.h2`
  font-size: 1.2rem;
  color: #1f2937;
  margin-bottom: 8px;
  font-weight: 700; /* Made bold as requested */
  text-align: center;
  width: 100%;
`;

export const ServicesRole = styled.span`
  font-size: 0.8rem;
  color: #1f2937;
  text-align: center;
  font-weight: 700;
  margin-bottom: 16px;
  width: 100%;
`;

export const ServicesH = styled.p`
  font-size: 0.9rem;
  color: #1f2937;
  text-align: center;
  font-weight: 700;
  margin-bottom: 8px;
`;
